import { useSelector } from "react-redux";
import { PAYLOAD_CONSTANTS } from "../components/au.mobile/checkout-info/constant";

const useEwPayload = () => {
    const { carDetails = {}, checkout = {} } = useSelector((state) => state) || {};
    const { content, isExtendedWarrantySelected, selectedEwPlan } = carDetails || {};
    const { order: { extendedWarrantyOpted } = {} } = checkout || {};

    const getEwParams = () => {
        if (!isExtendedWarrantySelected) return {};
        if (selectedEwPlan) {
            return {
                vasProductKey: selectedEwPlan?.ewKey,
                vasProductType: selectedEwPlan?.type
            };
        }
        const { ewDetails: {  type } = {} } = content || {};
        return {
            vasProductKey: selectedEwPlan?.ewKey,
            vasProductType: type
        };
    };

    const getEwRequestBody = () => {
        if (extendedWarrantyOpted && !isExtendedWarrantySelected) {
            return {
                action: PAYLOAD_CONSTANTS.REMOVE_EW
            };
        }
        return {};
    };

    return {
        ewRequestPayload: getEwParams(),
        ewRequestBody: getEwRequestBody()
    };
};

export default useEwPayload;
